import logo from './wse-logo.svg'

const WallstreetEnglishLogo: React.FC = () => (
    <img width='374' height='280' src={logo} alt='Wallstreet English' />
)

export { WallstreetEnglishLogo }
